import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-search-employee',
  templateUrl: './search-employee.component.html',
  styleUrls: ['./search-employee.component.css']
})
export class SearchEmployeeComponent implements OnInit {

  model = { 'table_name': 'employee', 'employee_no': '', 'name': '' };
  private dp = [];
  displayedColumns = ['employee_no', 'name', 'name_en', 'choose'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SearchEmployeeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }


  ngOnInit() {
  }

  search() {
    let condition = "";

    if (this.model['employee_no'] != '')
      condition += "`employee_no` LIKE '%" + this.model['employee_no'] + "%' AND ";

    if (this.model['name'] != '')
      condition += "(`name` LIKE '%" + this.model['name'] +
        "%' OR `name_en` LIKE '%" + this.model['name'] + "%') AND ";

    let query = "SELECT * FROM `employee` WHERE " + condition + 
      "`employee_no` NOT IN (SELECT `employee_no` FROM `user`) AND `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  chooseEmp(row) {
    this.dialog_data = {
      'name': row.name,
      'name_en': row.name_en,
      'employee_id': row.employee_id,
      'employee_no': row.employee_no,
      'branch_id': row.branch_id,
    };
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }


}
